/** Bundled tab thumbnails (used when sample menu store is active). */
const categoryPacksImage = require('./imgs/category-packs-thumb.png');
const categoryCakesImage = require('./imgs/category-cakes-thumb.png');
const categoryIceCreamImage = require('./imgs/category-ice-cream-thumb.png');

/** Default tab list; sample thumbs win over live menu product images when on sample store. */
export const giftingCategoryMenuMockItems = [
  {
    id: 'packs',
    label: 'Packs',
    imageUrl: categoryPacksImage,
    imageAlt: 'Cookie packs',
    sampleProducts: [],
  },
  {
    id: 'cakes',
    label: 'Cakes',
    imageUrl: categoryCakesImage,
    imageAlt: 'Cookie cakes',
    sampleProducts: [],
  },
  {
    id: 'ice-cream',
    label: 'Ice Cream',
    imageUrl: categoryIceCreamImage,
    imageAlt: 'Ice cream',
    sampleProducts: [],
  },
];

export const GIFTING_CATEGORY_SECTION_TITLE = 'MOST-GIFTED\nRIGHT NOW.';
